import styles from './style.module.css'

export default function Checkbox({isChecked,onChange,disabled,text=null,textStyle}){
    return(
        <>
        <label 
        onClick={(e)=>e.stopPropagation()}
        className={styles['checkbox-label']}>
            <input className={styles['checkbox-input']} type="checkbox" checked={isChecked} onChange={onChange} disabled={disabled}/>
            <span className={`${styles['checkbox-icon']} ${text&&textStyle}`}>{text&&text}</span>
        </label>
        </>
    )
}